import dom from "../../../dist/jsx-render/dom";
import { IAppComponent } from "../../Frame/IAppComponent";
import { app } from "../../Frame/App";
import { SearchPreview, SearchPreviewProps } from "./SearchPreview";

export class SearchBox {
    searchBox: HTMLInputElement;
    searchButton: HTMLDivElement;

    searchPreview: SearchPreview;

    initialize(): void {
        this.searchBox = document.querySelector(".frame-search-outer input");
        this.searchButton = document.querySelector(".frame-search-outer .frame-search-icon");

        if (this.searchBox) {
            this.searchBox.addEventListener("keyup", this.onSearchBoxKeyUp);
        }

        if (this.searchButton) {
            this.searchButton.addEventListener("click", this.onSearchButtonClick);
            this.searchButton.classList.add("pointer");
        }
    }

    onSearchBoxKeyUp = (event: KeyboardEvent) => {
        // on Enter, redirect to search page
        if (event.keyCode == 13) {
            this.redirectToSearchPage();
            return;
        }

        // display preview after three letters
        if (this.searchBox.value && this.searchBox.value.length > 2) {
            this.removePreviewBox();
            document.body.addEventListener("keyup", this.onBodyEscape);

            // show preview box
            let searchPreviewProps: SearchPreviewProps = {
                searchTerm: this.searchBox.value,
                parentInput:  this.searchBox,
                align: "right"
            }
            this.searchPreview = new SearchPreview(searchPreviewProps);

            document.body.appendChild(
                this.searchPreview.render()
            );

        } else {
            // remove preview box
            this.removePreviewBox();
        }
    }

    onBodyEscape = (event: KeyboardEvent) => {
        if (event.keyCode == 27) {
            this.removePreviewBox();
        }
    }

    onSearchButtonClick = (event: MouseEvent) => {
        this.redirectToSearchPage();
    }

    redirectToSearchPage = () => {
        let currentUrl = window.location.href;
        let searchTerm = this.searchBox.value;
        let returnUrl: string = encodeURI(currentUrl);

        // check if there is already a returnUrl present
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("returnUrl")) {
            returnUrl = urlParams.get("returnUrl");
        }

        // &returnUrl=${currentUrl}
        let url = app.resolveUrl(`~/search/result?searchTerm=${encodeURIComponent(searchTerm)}`);
        window.location.href = url;
    }

    removePreviewBox = () => {
        if (this.searchPreview) {
            app.destroyDomElements(this.searchPreview.element);

            document.body.removeEventListener("keyup", this.removePreviewBox);
        }
    }
}